<template>
  <component v-if="pageComponent" :is="pageComponent" :page="page" :slug="slug" class="leading-normal text-sm" />
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'
import MarketingPackNewOrderPage from './marketing-pack/MarketingPackNewOrderPage'
import MarketingPackOrderHistoryPage from './marketing-pack/MarketingPackOrderHistoryPage'
import Page from './Page'

export default {
  props: ['slug'],
  components: {
    MarketingPackNewOrderPage,
    MarketingPackOrderHistoryPage,
    Page
  },
  data () {
    return {
      page: null
    }
  },
  computed: {
    ...mapState([
      'pages', 'profile', 'selectedOffice', 'pagesLoading'
    ]),
    pageComponent () {
      return this.page && this.page.product_config.page_type ? `marketing-pack-${this.page.product_config.page_type}-page` : 'page'
    }
  },
  created () {
    this.loadPage()
  },
  methods: {
    loadPage () {
      this.page = find(this.pages, page => page.slug === this.slug)
    }
  },
  watch: {
    pages () {
      this.loadPage()
    }
  }
}
</script>
